__webpack_require__.p = "https://devcdn.infra.veevaappstats.com/app-stats/assets/";